module.exports = __webpack_public_path__ + "static/media/test-scan.5e8ef6e6.svg";